<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>


    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10 info-card">
                <span>Número</span>
                <strong class="right">{{ Funcoes.formatInteger(objView.cdos) }}</strong>
            </div>

            <div class="form-item-char10 info-card">
                <span>Data</span>
                <strong class="center">{{ Funcoes.formatDateFromJson(objView.dtabertura) }}</strong>
            </div>

            <div class="form-item info-card">
                <span>Dados</span>
                <strong>{{ objView.nmos }}</strong>
            </div>

            <div class="form-item-char40 info-card">
                <span>Situação</span>
                <strong class="center">{{ objView.nmstatus }}</strong>
            </div>
            
            <div class="form-item-char20 info-card info-card--highlight">
                <span>Valor Orçamento</span>
                <strong class="right">R$ {{ Funcoes.formatDecimal(objView.orcamento_valor) }}</strong>
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item info-card">
                <span>Equipamento/Veículo</span>
                <strong>{{ objView.nmequipamento }}</strong>
            </div>
            
            <div class="form-item-char10 info-card">
                <span>Placa</span>
                <strong class="center">{{ objView.placa }}</strong>
            </div>
            
            <div class="form-item info-card">
                <span>Fornecedor</span>
                <strong>{{ objView.nmfornecedor }}</strong>
            </div>
            
            <div class="form-item-char20 info-card info-card--highlight">
                <span>Valor Aprovado</span>
                <strong class="right">R$ {{ Funcoes.formatDecimal(objView.aprovacao_valor) }}</strong>
            </div>
        </div>

        <div class="row-end">
            <button v-if="objView.orcamento_idanexo" class="btn-small" @click="baixarAnexo(objView.orcamento_idanexo)">Orçamento</button>
            <button class="btn-small" @click="imprimirAF">Emitir AF</button>
            <button class="btn-small" @click="closeForm">Retornar</button>
        </div>
    </div>


    <section v-if="lsAnexos.length" class="form-panel margin-top05">
        <div class="form-panel-header">ANEXOS</div>
        <div class="anexos-lista">
            <button
                v-for="item in lsAnexos"
                :key="item.id"
                type="button"
                class="anexo-card"
                :title="`Baixar ${item.nmdoc}`"
                :aria-label="`Baixar ${item.nmdoc}`"
                @click="baixarAnexo(item.idanexo)"
            >
                <svg
                    class="anexo-icone"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.7"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                >
                    <path d="M12 3v12m-4-4 4 4 4-4" />
                    <path d="M5 16v4h14v-4" />
                </svg>

                <span class="anexo-info">
                    <span class="anexo-numero">
                        {{ item.nmtipo }}:
                        {{ Funcoes.formatInteger(item.docnro) }}
                    </span>

                    <span class="anexo-nome">
                        {{ item.nmdoc }}
                    </span>
                </span>
            </button>
        </div>
    </section>


    <div v-if="lsItensServico.length>0" class="form-panel margin-top05">
        <div class="form-panel-header">SERVIÇOS SOLICITADOS</div>
        <table>
            <thead><tr>
                <th>Código</th>
                <th>Nome/Descrição</th>
                <th>Status</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsItensServico" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-integer right">{{ Funcoes.formatInteger(obj.cdservico) }}</td>
                    <td>{{ obj.nmservico }}</td>
                    <td class="col-width-char20 center">{{ statusServico(obj) }}</td>
                </tr>
            </tbody>
        </table>
    </div>


    <div v-if="lsItensOrcamento.length>0" class="form-panel margin-top05">
        <div class="form-panel-header">ITENS DO ORÇAMENTO</div>
        <table>
            <thead><tr>
                <th>Ordem</th>
                <th>Item</th>
                <th>Horas</th>
                <th>Total</th>
                <th>Peças</th>
                <th>Orçado</th>
                <th>Autorizado</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsItensOrcamento" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-integer right">{{ obj.ordem }}</td>
                    <td>{{ obj.descricao }}</td>
                    <td class="col-width-char05 right">{{ Funcoes.formatDecimal(obj.qtdhoras) }}</td>
                    <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.aut_ttmo) }}</td>
                    <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.qtdd) }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.vlliquido) }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.aut_vlautorizado) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';

const emit = defineEmits(['close']);
const props = defineProps({idView: {type: Number, default: 0}});

const msgAlerta = ref(null);
const isLoading = ref(false);
const lsAnexos = ref([]);
const lsItensOrcamento = ref([]);
const lsItensServico = ref([]);
const objView = ref({});


async function baixarAnexo(idanexo) {
    if (!idanexo) {
        msgAlerta.value = 'ATENÇÃO: Documento sem anexo vinculado.';
        return;
    }
    
    try{
        msgAlerta.value=null;
        isLoading.value = true;
        const r = await Api.genericPost('/main/solicitar/download', {id: idanexo});
        if (r.bolok === 1){
            const url = r.download_url;
            window.open(url, '_blank');
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}


const closeForm = () => {
    emit('close'); 
}


async function lerDados() {
    if (!(props.idView > 0)) return;
    try{
        isLoading.value = true;
        const req = await Api.genericPost('/dados/manut_os', {
            idmunicipio: globalStore.idmunicipio,
            id: props.idView});

        if (req.length > 0){
            Object.assign(objView.value, req[0]);
            
            const itensOrc = await Api.genericPost('/frota/manut_os/itens/orcamento', {
                idmunicipio: globalStore.idmunicipio,
                idreferencia: props.idView});
            lsItensOrcamento.value = itensOrc;
            
            const itensServ = await Api.genericPost('/frota/manut_os/itens/servicos', {
                idmunicipio: globalStore.idmunicipio,
                idreferencia: props.idView});
            lsItensServico.value = itensServ;

            const anx = await Api.genericPost('/dados/manut_os_anexo', {
                idmunicipio: globalStore.idmunicipio,
                idreferencia: props.idView});
            lsAnexos.value = anx ?? [];
        }
    }catch (error){
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{
        isLoading.value = false;
    }
}


async function imprimirAF() {
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        const dados = {
            nmrelatorio: 'manutOsAF',
            id: props.idView,
            idmunicipio: globalStore.idmunicipio,
            idusuario: globalStore.idusuario,
            idlogin: globalStore.idlogin};
        const response = await Api.genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


function statusServico(item) {
    if (!objView.value?.execucao_data) {
        return 'Aguardando';
    }

    if (item.ckexecutado === 'S') {
        return 'Executado';
    }

    return 'Não executado';
}


onMounted(lerDados);
</script>


<style scoped>
.anexos-lista {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px;

    width: 100%;
    min-width: 0;
    padding: 6px;
    box-sizing: border-box;
}

.anexo-card {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;

    flex: 0 1 340px;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;

    /* Espaço para as duas linhas, mesmo com CSS global de botão. */
    height: auto;
    min-height: 30px;
    max-height: none;
    padding: 12px 14px;

    border: 1px solid #dce3eb;
    border-radius: 8px;
    background: #f8fafc;

    color: #2869a8;
    font: inherit;
    line-height: 1.2;
    text-align: left;
    white-space: normal;
    cursor: pointer;

    transition: background-color 0.15s, border-color 0.15s;
}

.anexo-card:hover {
    background: #edf5fc;
    border-color: #a9c6e2;
}

.anexo-card:focus-visible {
    outline: 2px solid #2869a8;
    outline-offset: 2px;
}

.anexo-icone {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}

.anexo-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
}

.anexo-numero {
    color: #687789;
    font-size: 12px;
}

.anexo-nome {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 600;
}

.anexo-card:hover .anexo-nome {
    text-decoration: underline;
}
</style>